import type { TFunction } from 'i18next';

/**
 * Person bucket titles. The bucket subtitles are shared verbatim across
 * pickers, so they stay on the `system` namespace.
 */
export function buildPersonBucketTitles(t: TFunction) {
  const withSuffix = (title: string, suffix: string | null) =>
    suffix ? `${title} · ${suffix}` : title;
  return {
    byRoleTitle: (roleName: string | null) =>
      withSuffix(t('entityPicker.user.buckets.byRole'), roleName),
    byRoleSubtitle: (peerCount: number) =>
      t('entityPicker.system.buckets.byRolePeerCount', { count: peerCount }),
    byDepartmentTitle: (deptName: string | null) =>
      withSuffix(t('entityPicker.user.buckets.byDepartment'), deptName),
    byDepartmentSubtitle: (peerCount: number) =>
      t('entityPicker.system.buckets.byDepartmentPeerCount', { count: peerCount }),
    byProcessTitle: (processName: string | null) =>
      withSuffix(t('entityPicker.user.buckets.byProcess'), processName),
    byProcessSubtitle: (sampleSize: number) =>
      t('entityPicker.system.buckets.byProcessSampleSize', { count: sampleSize })
  };
}
